import { Navigate, Route, Routes } from 'react-router-dom';

import GeneralSettingsPage from './general';
import { GeneralCustomerSettingsPage } from './Customer';
import OrderSettingsPage from './order';
import InvoiceSettingsPage from './invoice';
import EmailSettingsPage from './email/email';
import EmailTypeSettingsPage from './email/email-type';
import DocumentNoteSettingsPage from './document/doc';
import DocumentNoteTypeSettingsPage from './document/doc-type';
import { MailboxesSettingsPage } from './mailbox/Mailboxes';
import { ConfigureMailboxPage } from './mailbox/ConfigureMailbox';
import { UpdateMailboxPage } from './mailbox/UpdateMailbox';
import UsersPage from 'src/app/user/pages/Users';
import CreateUserPage from 'src/app/user/pages/CreateUser';
import UserPage from 'src/app/user/pages/User';
import { GeneralActionsPage } from './Actions';
import { CarrierInformationSettingsPage } from './carrier/CarrierInformation';

export const SettingsRoutes = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="general" replace />} />
      <Route path="general" element={<GeneralSettingsPage />} />
      <Route path="customer" element={<GeneralCustomerSettingsPage />} />
      <Route path="order" element={<OrderSettingsPage />} />
      <Route path="invoice" element={<InvoiceSettingsPage />} />
      <Route path="email" element={<EmailSettingsPage />}>
        <Route path=":emailType" element={<EmailTypeSettingsPage />} />
      </Route>
      <Route path="document" element={<DocumentNoteSettingsPage />}>
        <Route path=":docType" element={<DocumentNoteTypeSettingsPage />} />
      </Route>
      <Route path="mailbox">
        <Route index element={<MailboxesSettingsPage />} />
        <Route path="configure" element={<ConfigureMailboxPage />} />
        <Route path=":mailboxId" element={<UpdateMailboxPage />} />
      </Route>
      <Route path="users">
        <Route index element={<UsersPage />} />
        <Route path="new" element={<CreateUserPage />} />
        <Route path=":userId" element={<UserPage />} />
      </Route>
      <Route path="carrier-information" element={<CarrierInformationSettingsPage />} />
      <Route path="actions" element={<GeneralActionsPage />} />
    </Routes>
  );
};
